import { accountStateType, ActionType, reducerStoreType } from "./types";

const defaultState = {
  accountInfo: {
    orgCurrency: '',
    balanceAmt: 0,
    unsettledAmt: 0,
    canWithdrawAmt: 0,
    lowestAmt: 0,
    orgList: [],
    bankName: '',
    accountNo: '',
    accountName: '',
    accoutList: []
  },
  cashInfo: {
    clientId: '',
    email: '',
    withdrawAmt: 0
  }
}


const account = (state: accountStateType = defaultState, action: ActionType<any>) => {
  switch (action.type) {
    case 'SET_ACCOUNT_INFO':
      return {
        ...state,
        accountInfo: action.payload
      }
    case 'SET_CASH_INFO':
      return {
        ...state,
        cashInfo: {
          ...state.cashInfo,
          withdrawAmt: action.payload
        }
      }
    default:
      return state;
  }
}

export const cashInfo = (state: reducerStoreType) => (state.account.cashInfo)
export const accountInfo = (state: reducerStoreType) => (state.account.accountInfo)

export default account
